import { orgAPI } from "@/api/api";
import type { IntegrationConnectionWithSlug } from "@/api/integrations";
import type { ZoomRecordingEntity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface UseZoomGetRecordingProps {
  connection: IntegrationConnectionWithSlug | null | undefined;
  meetingId: string | null | undefined;
  enabled?: boolean;
  options?: Partial<UseQueryOptions<ZoomRecordingEntity | null, Error>>;
}

export function useZoomGetRecording({
  connection,
  meetingId,
  enabled = true,
  options = {},
}: UseZoomGetRecordingProps) {
  return useQuery({
    queryKey: ["zoom-recording-single", connection?.id, meetingId],
    queryFn: async () => {
      if (!connection || !meetingId) return null;

      // Fetch recording by UUID using MeetingTranscriptGet
      const response = await orgAPI.toolbox.execute<
        ZoomRecordingEntity,
        { meeting_id: string }
      >({
        integration_connection_id: connection?.id,
        action_name: "zoom-meeting-transcript-get",
        action_input: {
          meeting_id: meetingId,
        },
      });

      return response.data;
    },
    enabled: enabled && !!connection && !!meetingId,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    ...options,
  });
}
